// Foto della ricetta: un clic apre la foto grande sopra la pagina, un altro
// clic o Esc la chiude. Dove <dialog> non c'è, il link apre il file.
export function setupGallery() {
  if (typeof HTMLDialogElement !== 'function') return;
  const links = document.querySelectorAll('a[data-gallery]');
  if (!links.length) return;

  let viewer = document.querySelector('.gallery-viewer');
  if (!viewer) {
    viewer = document.createElement('dialog');
    viewer.className = 'gallery-viewer';
    viewer.innerHTML = '<img alt=""><p class="gallery-viewer__caption"></p>';
    viewer.addEventListener('click', () => viewer.close());
    document.body.appendChild(viewer);
  }

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey) return;
      event.preventDefault();
      const thumb = link.querySelector('img');
      const img = viewer.querySelector('img');
      img.src = link.href;
      img.alt = thumb ? thumb.alt : '';
      viewer.querySelector('p').textContent = img.alt;
      viewer.showModal();
    });
  });
}
